import { fromJS } from 'immutable';
import { actions } from 'react/api/actions/ticketDetails';

const initialState = fromJS({
  isLoading: true,
  isProcessingComment: false,
  isLoadingChatData: true
});

export default (state = initialState, action) => {
  switch (action.type) {
    case actions.setLoading:
      return state.set('isLoading', action.payload);
    case actions.setTicketDetails:
      return state.setIn([action.payload.screenKey], fromJS(action.payload.data));
    case actions.setCommentToState: {
      const { screenKey, commentToState } = action.payload;
      return state.updateIn([screenKey, 'comments'], (comments) => comments.push(fromJS(commentToState)));
    }
    case actions.updateACommentOnState: {
      const { screenKey, commentToState } = action.payload;

      const comments = state.getIn([screenKey, 'comments']);
      const commentToUpdateIndex = comments.findIndex(
        (comment) => comment.get('id') === commentToState.id
      );

      return state.updateIn([screenKey, 'comments', commentToUpdateIndex], (comment) => {
        let commentUpdatedState;
        commentUpdatedState = comment.set('note', commentToState.note);
        commentUpdatedState = commentUpdatedState.set('when', commentToState.when);
        return commentUpdatedState;
      });
    }
    case actions.setProcessingComment:
      return state.set('isProcessingComment', action.payload);
    case actions.deleteCommentOnState: {
      const { screenKey, commentId } = action.payload;

      return state.updateIn([screenKey, 'comments'], (comments) => (
        comments.filter((comment) => comment.get('id') !== commentId)
      ));
    }
    case actions.setLoadingChats:
      return state.set('isLoadingChatData', action.payload);
    case actions.setChatsToState:
      return state.setIn([action.payload.screenKey, 'chats'], fromJS(action.payload.chats));

    default:
      return state;
  }
};
